import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface Region {
  id: number
  name: string
}

export async function getRegions(
  project_id: number,
  options?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.get<Region[]>(
    apiRoutes.getRegions(project_id),
    options,
  )
  return data
}
